import React from 'react';
import _ from 'lodash';

import WorkerSettingsContext from '../../services/workerSettings/WorkerSettingsContext';
import FieldTreesApi from '../../services/fieldTrees/FieldTreesApi';
import FieldTreesService from '../../services/fieldTrees/FieldTreesService';
import { SearchMenuHeader } from './SearchMenuHeader';
import { TextBox } from '../textbox/TextBox';
import DropdownSelector from '../dropdowns/DropdownSelector';
import MultiSelectDropdownSaveOnClose from '../dropdowns/MultiSelectDropdownSaveOnClose';
import {
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  WORKER_IMAGE_REGISTER_STATUS,
  ERROR_STATUS,
  FIELD_TREE_WORKER_CCUS_SYNCED_STATUS,
  CONNECT_WORK_HISTORY_STATUS,
  CCUS_ENGINEER_ID_STATUS,
  WORKER_SETTING_STATUS,
} from '../../utilities/constants';
import Styles from '../../styles/componentStyle/workerSettings/WorkerSettings.scss';
import { isNullOrEmpty } from '../../utilities/stringUtil';

const MAIN_JV_COMPANY = 1;

/**
 * 作業員設定状況一覧検索フォーム (顔写真)
 * @props {string}propertyName:ステート内のプロパティ名
 */
export class FacePictureSearchForm extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <WorkerSettingsContext.Consumer>
        {({
          state,
          searchFormHandle,
          clearSearchProperty,
          searchFieldTreeId,
          inputWorkerName,
          checkSingleData,
          searchCompanyId,
          searchClickHandle,
        }) => (
          <div className={`${Styles.search} master-slide-view__searchform`}>
            <div className='search-form'>
              <SearchMenuHeader
                total={state[this.props.propertyName].total}
                isOpened={state[this.props.propertyName].isOpened}
                accordionButtonClass={this.props.propertyName}
                clearButtonName={this.props.propertyName}
                searchFormHandle={() => {
                  searchFormHandle(this.props.propertyName);
                }}
                clearSearchProperty={() => {
                  clearSearchProperty(this.props.propertyName);
                }}
              />
              <div
                id='search-form-accordion'
                className={`${this.props.propertyName} ${
                  state[this.props.propertyName].isOpened
                    ? 'accordion show'
                    : 'accordion'
                }`}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      {/* 所属会社 */}
                      {!isNullOrEmpty(state.fieldId) && (
                        <div className='search-form-element'>
                          <div className='multi-select-box__label'>
                            <span className='label'>
                              {data.searchTitle.companyName}
                            </span>
                          </div>
                          <div className='multi-select-box__element'>
                            <DropdownSelector
                              widthClass='dropdown__item--wide'
                              label={data.placeholder.companyName}
                              selectorName={this.props.propertyName}
                              selectedValues={state.searchForm.fieldTreeIds}
                              keyName='name'
                              valueName='field_tree_id'
                              multiple
                              api={param =>
                                FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                  state.fieldId,
                                  FieldTreesService.createSearchFieldTreeCompanyBranchList(
                                    param
                                  )
                                )
                              }
                              apiSearchKey='name'
                              apiBindDataKey='field_trees'
                              apiParams={state.fieldTreeBranchSearchForm}
                              onSelect={(name, values) => {
                                searchFieldTreeId(values);
                              }}
                              clearFlag={state.searchForm.clearFlag}
                            />
                          </div>
                        </div>
                      )}
                      {/* 一次協力会社 */}
                      {!isNullOrEmpty(state.fieldId) && (
                        <div className='search-form-element'>
                          <div className='multi-select-box__label'>
                            <span className='label'>
                              {data.searchTitle.primaryCompanyName}
                            </span>
                          </div>
                          <div className='multi-select-box__element'>
                            <DropdownSelector
                              widthClass='dropdown__item--wide'
                              itemWidthClass='multi-select__item'
                              label={data.placeholder.primaryCompanyName}
                              dropdownSelectStyle={{ width: '190px' }}
                              selectorName={this.props.propertyName}
                              selectedValues={state.searchForm.companyIds}
                              keyName='company_name'
                              valueName='company_id'
                              multiple
                              api={param =>
                                FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                  state.fieldId,
                                  { ...param, nest_no: MAIN_JV_COMPANY }
                                )
                              }
                              apiSearchKey='name'
                              apiBindDataKey='field_trees'
                              apiParams={state.fieldTreeBranchSearchForm}
                              onSelect={(name, values) => {
                                searchCompanyId(values);
                              }}
                              clearFlag={state.searchForm.clearFlag}
                            />
                          </div>
                        </div>
                      )}
                      {/* 作業員名 */}
                      <div className='search-form-element search-form-element__input'>
                        <TextBox
                          label={data.searchTitle.workerName}
                          name={this.props.propertyName}
                          placeholder={data.placeholder.workerName}
                          value={state[this.props.propertyName].workerName}
                          onInput={event => {
                            inputWorkerName(event);
                          }}
                        />
                      </div>
                      {/* ステータス */}
                      <MultiCheckbox
                        label={data.searchTitle.status}
                        options={WORKER_SETTING_STATUS}
                        data={state.searchForm}
                        listName='workerSettingStatusList'
                        onChange={checkSingleData}
                        checked='false'
                      />
                      {/* 顔写真 */}
                      <MultiCheckbox
                        label={data.searchTitle.faceImage}
                        options={WORKER_IMAGE_REGISTER_STATUS}
                        data={state.searchForm}
                        listName='workerImageRegisterStatusList'
                        onChange={checkSingleData}
                      />
                      {/* 顔認証機器連携 */}
                      <MultiCheckbox
                        label={data.searchTitle.connectedFaceMachine}
                        options={_.filter(
                          WORKER_IMAGE_CCUS_SYNCED_STATUS,
                          'canSearch'
                        )}
                        data={state.searchForm}
                        listName='workerImageCcusSyncedStatusList'
                        onChange={checkSingleData}
                      />
                      {/* エラー状況 */}
                      <MultiCheckbox
                        label={data.searchTitle.hasError}
                        options={ERROR_STATUS}
                        data={state.searchForm}
                        listName='hasErrorList'
                        onChange={checkSingleData}
                      />
                      {/* 検索 */}
                      <SearchButton onClick={searchClickHandle} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </WorkerSettingsContext.Consumer>
    );
  }
}

/**
 * 作業員設定状況一覧検索フォーム (CCUS)
 * @props {string}propertyName:ステート内のプロパティ名
 */
export class CcusSearchForm extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <WorkerSettingsContext.Consumer>
        {({
          state,
          searchFormHandle,
          clearSearchProperty,
          searchFieldTreeId,
          searchCompanyId,
          searchConnectStatus,
          inputWorkerName,
          checkSingleData,
          searchClickHandle,
        }) => (
          <div className={`${Styles.search} master-slide-view__searchform`}>
            <div className='search-form'>
              <SearchMenuHeader
                total={state[this.props.propertyName].total}
                isOpened={state[this.props.propertyName].isOpened}
                accordionButtonClass={this.props.propertyName}
                clearButtonName={this.props.propertyName}
                searchFormHandle={() => {
                  searchFormHandle(this.props.propertyName);
                }}
                clearSearchProperty={() => {
                  clearSearchProperty(this.props.propertyName);
                }}
              />
              <div
                id='search-form-accordion'
                className={`${this.props.propertyName} ${
                  state[this.props.propertyName].isOpened
                    ? 'accordion show'
                    : 'accordion'
                }`}
              >
                <div className='search-form__body'>
                  <div className='form form--search-form'>
                    <div className='form__group flex-wrap'>
                      {/* 所属会社 */}
                      {!isNullOrEmpty(state.fieldId) && (
                        <div className='search-form-element'>
                          <div className='multi-select-box__label'>
                            <span className='label'>
                              {data.searchTitle.companyName}
                            </span>
                          </div>
                          <div className='multi-select-box__element'>
                            <DropdownSelector
                              widthClass='dropdown__item--wide'
                              label={data.placeholder.companyName}
                              selectorName={this.props.propertyName}
                              selectedValues={state.searchForm.fieldTreeIds}
                              keyName='name'
                              valueName='field_tree_id'
                              multiple
                              api={param =>
                                FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                  state.fieldId,
                                  FieldTreesService.createSearchFieldTreeCompanyBranchList(
                                    param
                                  )
                                )
                              }
                              apiSearchKey='name'
                              apiBindDataKey='field_trees'
                              apiParams={state.fieldTreeBranchSearchForm}
                              onSelect={(name, values) => {
                                searchFieldTreeId(values);
                              }}
                              clearFlag={state.searchForm.clearFlag}
                            />
                          </div>
                        </div>
                      )}
                      {/* 一次協力会社 */}
                      <div className='search-form-element'>
                        <div className='multi-select-box__label'>
                          <span className='label'>
                            {data.searchTitle.primaryCompanyName}
                          </span>
                        </div>
                        <div className='multi-select-box__element'>
                          <DropdownSelector
                            widthClass='dropdown__item--wide'
                            itemWidthClass='multi-select__item'
                            label={data.placeholder.primaryCompanyName}
                            dropdownSelectStyle={{ width: '190px' }}
                            selectorName={this.props.propertyName}
                            selectedValues={state.searchForm.companyIds}
                            keyName='company_name'
                            valueName='company_id'
                            multiple
                            api={param =>
                              FieldTreesApi.fetchFieldTreeCompanyBranchList(
                                state.fieldId,
                                { ...param, nest_no: MAIN_JV_COMPANY }
                              )
                            }
                            apiSearchKey='name'
                            apiBindDataKey='field_trees'
                            apiParams={state.fieldTreeBranchSearchForm}
                            onSelect={(name, values) => {
                              searchCompanyId(values);
                            }}
                            clearFlag={state.searchForm.clearFlag}
                          />
                        </div>
                      </div>
                      {/* 作業員名 */}
                      <div className='search-form-element search-form-element__input'>
                        <TextBox
                          label={data.searchTitle.workerName}
                          name={this.props.propertyName}
                          placeholder={data.placeholder.workerName}
                          value={state[this.props.propertyName].workerName}
                          onInput={inputWorkerName}
                        />
                      </div>
                      {/* ステータス */}
                      <MultiCheckbox
                        label={data.searchTitle.status}
                        options={WORKER_SETTING_STATUS}
                        data={state.searchForm}
                        listName='workerSettingStatusList'
                        onChange={checkSingleData}
                        checked='false'
                      />
                      {/* CCUS技能者ID */}
                      <MultiCheckbox
                        label={data.searchTitle.ccusEngineerId}
                        options={CCUS_ENGINEER_ID_STATUS}
                        data={state.searchForm}
                        listName='fieldCcusEngineerIdStatus'
                        onChange={checkSingleData}
                      />
                      {/* 就業履歴送信 */}
                      <MultiCheckbox
                        label={data.searchTitle.connectWorkHistoryStatus}
                        options={CONNECT_WORK_HISTORY_STATUS}
                        data={state.searchForm}
                        listName='fieldConnectWorkHistoryStatus'
                        onChange={checkSingleData}
                      />
                      {/* 施工体制連携 */}
                      {/*  BLDE_V2-50226 複数のチェックボックスを持つドロップダウンのコンポネントの追加 */}
                      <div className='search-form-element'>
                        <div className='multi-select-box__label'>
                          <span className='label'>
                            {data.searchTitle.ccusConnect}
                          </span>
                        </div>
                        <div className='multi-select-box__element'>
                          <MultiSelectDropdownSaveOnClose
                            widthClass={'worker-setting-multi-select-dropdown'}
                            label={data.placeholder.ccusConnect}
                            dropdownSelectStyle={{ width: '190px' }}
                            selected={_.map(
                              state.searchForm
                                .fieldTreeWorkerCcusSyncedStatusList,
                              'ID'
                            )}
                            keyName='NAME'
                            selectAll={state.searchForm.selectAll}
                            valueName='ID'
                            options={FIELD_TREE_WORKER_CCUS_SYNCED_STATUS}
                            onSelect={values => {
                              searchConnectStatus(values);
                            }}
                          />
                        </div>
                      </div>
                      {/* 検索 */}
                      <SearchButton onClick={searchClickHandle} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </WorkerSettingsContext.Consumer>
    );
  }
}

const SearchButton = ({ onClick }) => (
  <div className='search-form-element'>
    <button className='btn-fixedsize--stay search-form__btn' onClick={onClick}>
      {data.searchButtonTitle}
    </button>
  </div>
);

export const MultiCheckbox = ({ label, options, data, listName, onChange }) => (
  <div className='search-form-element'>
    <div className='form__label'>
      <span className='label'>{label}</span>
    </div>
    <div className='form__element'>
      {_.map(options, item => (
        <label className='checkbox' key={item.ID || item.id}>
          <input
            type='checkbox'
            name='checkbox'
            checked={_.some(data[listName], item)}
            onChange={() => onChange(listName, item)}
          />
          <i className='i-square i-2x' aria-hidden='true' />
          <span className='radio-search-span'>{item.NAME || item.name}</span>
        </label>
      ))}
    </div>
  </div>
);

// 定数
const data = {
  clearButtonTitle: '検索条件クリア',
  searchButtonTitle: '検索',
  searchTitle: {
    companyName: '所属会社',
    status: 'ステータス',
    faceImage: '顔写真',
    hasError: 'エラー状況',
    workerName: '氏名（カナ検索可）',
    connectedFaceMachine: '顔写真送信',
    ccusConnect: '施工体制連携',
    primaryCompanyName: '一次協力会社',
    ccusEngineerId: 'CCUS技能者ID',
    connectWorkHistoryStatus: '就業履歴送信',
  },
  placeholder: {
    primaryCompanyName: '一次協力会社を選択',
    companyName: '所属会社を選択',
    workerName: '作業員名を入力',
    ccusConnect: '施工体制連携を選択',
  },
};



// WEBPACK FOOTER //
// ./src/components/searchmenus/WorkerSettingsSearch.jsx